// extracted by mini-css-extract-plugin
export default {"voucherContainer":"PinsDisplay_voucherContainer__JB55l","actionButtonLink":"PinsDisplay_actionButtonLink__zRPcw"};